import axios from '../../../HttpRequests/axios';

export const FETCH_INVOICE_BREAKDOWN_REQUEST = 'FETCH_INVOICE_BREAKDOWN_REQUEST';
export const FETCH_INVOICE_BREAKDOWN_SUCCESS = 'FETCH_INVOICE_BREAKDOWN_SUCCESS';
export const FETCH_INVOICE_BREAKDOWN_FAILURE = 'FETCH_INVOICE_BREAKDOWN_FAILURE';

export default function fetchInvoiceBreakdown() {
  return (dispatch) => {
    dispatch({ type: FETCH_INVOICE_BREAKDOWN_REQUEST });

    return axios
      .get('/dashboard/invoices/breakdown')
      .then((response) => {
        dispatch({
          type: FETCH_INVOICE_BREAKDOWN_SUCCESS,
          payload: response.data.data,
        });
        return response.data.data;
      })
      .catch((error) => {
        console.error('Invoice Breakdown Error:', error);
        dispatch({
          type: FETCH_INVOICE_BREAKDOWN_FAILURE,
          payload: error.message || 'Failed to load invoice breakdown',
        });
        throw error;
      });
  };
}
